// import React, { useState, useCallback, useEffect, useMemo } from 'react';
// import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
// import { NIGHT_EYE_IMG_URL } from '../../../Process';

// const containerStyle = {
//   width: '100%',
//   height: '100%',
// };

// const defaultCenter = {
//   lat: 21.1702, // Surat center as fallback
//   lng: 72.8311,
// };

// const DashboardMapPreview = ({ departmentDashboardData }) => {
//   const [map, setMap] = useState(null);
//   const [selectedShop, setSelectedShop] = useState(null);

//   // Checkbox states - both selected by default
//   const [showCompliant, setShowCompliant] = useState(true);
//   const [showViolations, setShowViolations] = useState(true);

//   // Safely extract arrays
//   const shopOpenData = Array.isArray(departmentDashboardData?.[0]?.ShopOpenDetailData)
//     ? departmentDashboardData[0].ShopOpenDetailData
//     : [];

//   const violationData = Array.isArray(departmentDashboardData?.[0]?.ActiveViolationsData)
//     ? departmentDashboardData[0].ActiveViolationsData
//     : [];

//   // Combine and tag shops
//   const allShops = [
//     ...shopOpenData.map(shop => ({ ...shop, type: 'compliant' })),
//     ...violationData.map(shop => ({ ...shop, type: 'violation' })),
//   ];

//   // Remove duplicates by ShopDetailID
//   const uniqueShops = Array.from(
//     new Map(allShops.map(shop => [shop.ShopDetailID, shop])).values()
//   );

//   // Filtered shops based on checkbox selection
//   const displayedShops = useMemo(() => {
//     return uniqueShops.filter(shop => {
//       if (shop.type === 'compliant') return showCompliant;
//       if (shop.type === 'violation') return showViolations;
//       return false;
//     });
//   }, [uniqueShops, showCompliant, showViolations]);

//   const { isLoaded } = useJsApiLoader({
//     id: 'google-map-script',
//     googleMapsApiKey: 'AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o',
//   });

//   const onMapLoad = useCallback(
//     (mapInstance) => {
//       setMap(mapInstance);

//       if (displayedShops.length === 0) {
//         mapInstance.setCenter(defaultCenter);
//         mapInstance.setZoom(11);
//         return;
//       }

//       const bounds = new window.google.maps.LatLngBounds();
//       let hasValidPosition = false;

//       displayedShops.forEach((shop) => {
//         const lat = parseFloat(shop.Latitude);
//         const lng = parseFloat(shop.Longitude);

//         if (!isNaN(lat) && !isNaN(lng)) {
//           bounds.extend({ lat, lng });
//           hasValidPosition = true;
//         }
//       });

//       if (hasValidPosition) {
//         mapInstance.fitBounds(bounds, {
//           top: 80,
//           bottom: 80,
//           left: 50,
//           right: 50,
//         });
//       } else {
//         mapInstance.setCenter(defaultCenter);
//         mapInstance.setZoom(11);
//       }
//     },
//     [displayedShops] // Re-fit when displayed shops change
//   );

//   const onUnmount = useCallback(() => {
//     setMap(null);
//   }, []);

//   if (!isLoaded) {
//     return (
//       <div className="h-full flex items-center justify-center bg-slate-100 dark:bg-slate-900">
//         <div className="text-slate-500 dark:text-slate-400 animate-pulse">
//           Loading map...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="lg:col-span-2 flex flex-col rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 overflow-hidden shadow-sm h-full">
//       {/* Header */}
//       <div className="p-4 border-b border-slate-100 dark:border-slate-700 flex flex-wrap justify-between items-center gap-4 bg-slate-50/50 dark:bg-slate-800/50">
//         <h3 className="font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
//           <span className="material-symbols-outlined text-slate-500">map</span>
//           Zone Map Overview
//         </h3>

//         <div className="flex flex-wrap gap-3">
//           {/* Compliant Checkbox */}
//           <label className="flex items-center gap-1.5 text-xs font-medium text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-900 px-3 py-1 rounded border border-slate-200 dark:border-slate-700 shadow-sm cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/80 transition-colors">
//             <input
//               type="checkbox"
//               checked={showCompliant}
//               onChange={(e) => setShowCompliant(e.target.checked)}
//               className="w-3.5 h-3.5 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500"
//             />
//             <span className="size-2.5 rounded-full bg-emerald-500" />
//             Compliant ({shopOpenData.length})
//           </label>

//           {/* Violation Checkbox */}
//           <label className="flex items-center gap-1.5 text-xs font-medium text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-900 px-3 py-1 rounded border border-slate-200 dark:border-slate-700 shadow-sm cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/80 transition-colors">
//             <input
//               type="checkbox"
//               checked={showViolations}
//               onChange={(e) => setShowViolations(e.target.checked)}
//               className="w-3.5 h-3.5 rounded border-slate-300 text-red-600 focus:ring-red-500"
//             />
//             <span className="size-2.5 rounded-full bg-red-500" />
//             Violation ({violationData.length})
//           </label>
//         </div>
//       </div>

//       {/* Map */}
//       <div className="relative w-full flex-1">
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           onLoad={onMapLoad}
//           onUnmount={onUnmount}
//           options={{
//             zoomControl: true,
//             mapTypeControl: false,
//             streetViewControl: false,
//             fullscreenControl: true,
//             styles: [
//               { featureType: 'poi.business', elementType: 'labels', stylers: [{ visibility: 'off' }] },
//             ],
//           }}
//         >
//           {displayedShops.map((shop) => {
//             const lat = parseFloat(shop.Latitude);
//             const lng = parseFloat(shop.Longitude);

//             if (isNaN(lat) || isNaN(lng)) return null;

//             const isViolation = shop.type === 'violation';

//             return (
//               <Marker
//                 key={shop.ShopDetailID}
//                 position={{ lat, lng }}
//                 icon={{
//                   url: isViolation
//                     ? 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
//                     : 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
//                   scaledSize: new window.google.maps.Size(32, 32),
//                 }}
//                 onClick={() => setSelectedShop(shop)}
//               />
//             );
//           })}

//           {selectedShop && (
//         <InfoWindow
//   position={{
//     lat: parseFloat(selectedShop.Latitude),
//     lng: parseFloat(selectedShop.Longitude),
//   }}
//   options={{
//     closeBoxURL: "",                    // ← empty string = no default X button
//     closeBoxMargin: "0px",              // no extra margin around close area
//     pixelOffset: new window.google.maps.Size(0, -30), // optional: center adjustment

//   }}
//   onCloseClick={() => setSelectedShop(null)}
// >
//  <div className="w-[260px] sm:w-[280px] bg-white dark:bg-slate-800 rounded-lg    overflow-hidden relative">
//     {/* Custom close button – placed very close to top-right edge */}
//     <button
//       onClick={() => setSelectedShop(null)}
//       className="absolute top-0 right-1 z-30 flex h-7 w-7 items-center justify-center rounded-full bg-white/90 hover:bg-gray-100 dark:bg-slate-800/90 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300 shadow-sm transition-colors backdrop-blur-sm"
//       aria-label="Close"
//     >
//       <span className="material-symbols-outlined text-lg">close</span>
//     </button>

//     {/* Content starts almost immediately – minimal top padding */}
//     <div className="flex items-start gap-3 p-3 pt-2">
//       {/* Shop image */}
//       <img
//         src={`${NIGHT_EYE_IMG_URL}SmartCollection/ShopImage/${selectedShop.ShopImage}`}
//         alt={selectedShop.ShopName || "Shop"}
//         className="size-14 rounded-md object-cover  flex-shrink-0 "
//         onError={(e) => {
//           e.target.src = "https://via.placeholder.com/56?text=Shop";
//         }}
//       />

//       {/* Text content */}
//       <div className="flex-1 min-w-0">
//         <h4 className="font-semibold text-base leading-tight text-slate-900 dark:text-slate-100 truncate">
//           {selectedShop.ShopName || "Unnamed Shop"}
//         </h4>

//         <div className="mt-1.5 space-y-1 text-sm">
//           <div className="flex items-center gap-1.5 text-slate-700 dark:text-slate-300">
//             <span className="material-symbols-outlined text-sm">location_on</span>
//             <span className="font-medium truncate">{selectedShop.AreaName || "—"}</span>
//           </div>

//           {selectedShop.Address && (
//             <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed line-clamp-2">
//               {selectedShop.Address}
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   </div>
// </InfoWindow>
//           )}
//         </GoogleMap>
//       </div>
//     </div>
//   );
// };

// export default DashboardMapPreview;

import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from "@react-google-maps/api";
import { NIGHT_EYE_IMG_URL } from "../../../Process";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = { lat: 21.1702, lng: 72.8311 }; // Surat fallback

const DashboardMapPreview = ({ departmentDashboardData }) => {
  const [map, setMap] = useState(null);
  const [selectedShop, setSelectedShop] = useState(null);

  const [showCompliant, setShowCompliant] = useState(true);
  const [showViolations, setShowViolations] = useState(true);
  const [showVendor, setShowVendor] = useState(true);

  const shopOpenData = Array.isArray(departmentDashboardData?.[0]?.ShopOpenDetailData) ? departmentDashboardData[0].ShopOpenDetailData : [];

  const violationData = Array.isArray(departmentDashboardData?.[0]?.ActiveViolationsData) ? departmentDashboardData[0].ActiveViolationsData : [];

  const vendorData = Array.isArray(departmentDashboardData?.[0]?.OverallVendorJSONData) ? departmentDashboardData?.[0]?.OverallVendorJSONData : [];

  // If same shop can be in both lists → decide priority (here: violation wins)
  const allShops = useMemo(() => {
    const map = new Map();

    // Violation has higher priority (overwrites compliant)
    violationData.forEach((shop) => {
      map.set(shop.ShopReportDetailID, { ...shop, type: "violation" });
    });

    shopOpenData.forEach((shop) => {
      if (!map.has(shop.ShopDetailID)) {
        map.set(shop.ShopDetailID, { ...shop, type: "compliant" });
      }
    });

    vendorData.forEach((vendor) => {
      if (!map.has(vendor.ShopDetailID)) {
        map.set(vendor.ShopDetailID, { ...vendor, type: "vendor" });
      }
    });

    return Array.from(map.values());
  }, [shopOpenData, violationData, vendorData]);

  // Could also do simple concat + filter if no overlap expected:
  // const allShops = [
  //   ...shopOpenData.map(s => ({ ...s, type: 'compliant' })),
  //   ...violationData.map(s => ({ ...s, type: 'violation' })),
  // ];

  const displayedShops = useMemo(() => {
    return allShops.filter((shop) => {
      if (shop.type === "compliant") return showCompliant;
      if (shop.type === "violation") return showViolations;
      if (shop.type === "vendor") return showVendor;
      return false;
    });
  }, [allShops, showCompliant, showViolations, showVendor]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o",
  });

  // Fit bounds whenever displayed shops change
  useEffect(() => {
    if (!map || !isLoaded || displayedShops.length === 0) {
      if (map) {
        map.setCenter(defaultCenter);
        map.setZoom(11);
      }
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    let hasValidPosition = false;

    displayedShops.forEach((shop) => {
      const lat = parseFloat(shop.Latitude);
      const lng = parseFloat(shop.Longitude);
      if (!isNaN(lat) && !isNaN(lng)) {
        bounds.extend({ lat, lng });
        hasValidPosition = true;
      }
    });

    if (hasValidPosition) {
      // You can tune padding or remove it
      map.fitBounds(bounds, { top: 60, bottom: 100, left: 40, right: 40 });
    } else {
      map.setCenter(defaultCenter);
      map.setZoom(11);
    }
  }, [map, isLoaded, displayedShops]);

  const onMapLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  if (!isLoaded) {
    return <div className="h-full grid place-items-center">Loading map...</div>;
  }
  console.log("sdjflkdsjfkdsafjsadf", displayedShops);
  return (
    <div className="lg:col-span-2 flex flex-col rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 overflow-hidden shadow-sm h-full">
      {/* Header with checkboxes */}
      <div className="p-4 border-b flex flex-wrap justify-between items-center gap-4">
        <h3 className="font-bold flex items-center gap-2">
          <span className="material-symbols-outlined">map</span>
          Zone Map – Vendor Details
        </h3>

        <div className="flex gap-3 flex-wrap">
          <label className="flex items-center gap-1.5 text-xs font-medium ...">
            <input type="checkbox" checked={showVendor} onChange={(e) => setShowVendor(e.target.checked)} className="w-4 h-4 text-emerald-600 ..." />
            <span className="size-2.5 rounded-full bg-emerald-500" />
            Vendors ({vendorData?.length})
          </label>
          <label className="flex items-center gap-1.5 text-xs font-medium ...">
            <input type="checkbox" checked={showCompliant} onChange={(e) => setShowCompliant(e.target.checked)} className="w-4 h-4 text-emerald-600 ..." />
            <span className="size-2.5 rounded-full bg-blue-500" />
            Not Made Entry ({shopOpenData?.length})
          </label>

          <label className="flex items-center gap-1.5 text-xs font-medium ...">
            <input type="checkbox" checked={showViolations} onChange={(e) => setShowViolations(e.target.checked)} className="w-4 h-4 text-red-600 ..." />
            <span className="size-2.5 rounded-full bg-red-500" />
            Violations Reported ({violationData?.length})
          </label>
        </div>
      </div>

      <div className="flex-1 relative">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={defaultCenter}
          zoom={11}
          onLoad={onMapLoad}
          options={{
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true,
            styles: [{ featureType: "poi.business", elementType: "labels", stylers: [{ visibility: "off" }] }],
          }}
        >
          {/* {displayedShops.map((shop) => {
            const lat = parseFloat(shop.Latitude);
            const lng = parseFloat(shop.Longitude);
            if (isNaN(lat) || isNaN(lng)) return null;

            const isViolation = shop.type === "violation";

            return (
              <Marker
                key={isViolation ? shop.ShopReportDetailID : shop.ShopDetailID}
                position={{ lat, lng }}
                icon={{
                  url: isViolation ? "http://maps.google.com/mapfiles/ms/icons/red-dot.png" : "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                  scaledSize: new window.google.maps.Size(32, 32),
                }}
                onClick={() => setSelectedShop(shop)}
              />
            );
          })} */}

          {displayedShops?.map((shop) => {
            const lat = parseFloat(shop.Latitude);
            const lng = parseFloat(shop.Longitude);
            if (isNaN(lat) || isNaN(lng)) return null;

            const markerConfig = {
              violation: {
                key: shop.ShopReportDetailID,
                icon: "/iconImages/red.png",
              },
              compliant: {
                key: shop.ShopDetailID,
                icon: "/iconImages/blue.png",
              },
              vendor: {
                key: shop.VendorID,
                icon: "/iconImages/green.png",
              },
            };

            const config = markerConfig[shop.type];
            if (!config) return null;

            return (
              <Marker
                key={config.key}
                position={{ lat, lng }}
                icon={{
                  url: config.icon,
                  scaledSize: new window.google.maps.Size(32, 32),
                }}
                onClick={() => setSelectedShop(shop)}
              />
            );
          })}

          {selectedShop && (
            <InfoWindow
              position={{
                lat: parseFloat(selectedShop.Latitude),
                lng: parseFloat(selectedShop.Longitude),
              }}
              onCloseClick={() => setSelectedShop(null)}
              options={{
                closeBoxURL: "",
                pixelOffset: new window.google.maps.Size(0, -35),
              }}
            >
              {/* your nice custom content with close button */}
              <div className="w-72 bg-white dark:bg-slate-800 rounded-lg shadow-lg relative p-3">
                <button
                  onClick={() => setSelectedShop(null)}
                  className="absolute -top-2 -right-2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white dark:bg-slate-700 shadow hover:bg-gray-100 ..."
                >
                  <span className="material-symbols-outlined">close</span>
                </button>

                <div className="flex gap-3">
                  <img
                    src={`${NIGHT_EYE_IMG_URL}SmartCollection/ShopImage/${selectedShop.ShopImage}`}
                    alt={selectedShop.ShopName}
                    className="size-16 rounded object-cover"
                    onError={(e) => (e.target.src = "https://via.placeholder.com/64?text=No+Image")}
                  />
                  <div>
                    <h4 className="font-semibold">{selectedShop.ShopName || "Shop"}</h4>
                    <div className="text-sm mt-1 space-y-1 text-gray-600 dark:text-gray-300">
                      <div className="flex items-center gap-1">
                        <span className="material-symbols-outlined text-base">location_on</span>
                        {selectedShop.AreaName || "—"}
                      </div>
                      {selectedShop.Address && <p className="text-xs line-clamp-2">{selectedShop.Address}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </div>
    </div>
  );
};

export default DashboardMapPreview;
